export default __webpack_public_path__ + "static/media/cover-image-placeholder.314f959b.jpeg";